/**
 * S3 Upload actions
 * @module actions/s3Upload
 */

import { UPLOAD_S3_FILE } from '../constants/ActionTypes';

/**
 * Upload file to S3
 * @function uploadS3File
 * @param {string} url Base URL (usually from pathname)
 * @param {File} file File object to upload
 * @param {Object} options Upload options (folder, etc)
 * @param {string} subrequest Optional subrequest key
 * @returns {Object} Upload S3 file action
 */
export function uploadS3File(url, file, options = {}, subrequest) {
  const formData = new FormData();
  formData.append('file', file);

  if (options.folder) {
    formData.append('folder', options.folder);
  }

  if (options.filename) {
    formData.append('filename', options.filename);
  }

  return {
    type: UPLOAD_S3_FILE,
    subrequest,
    request: {
      op: 'post',
      path: `${url}/@s3`,
      data: formData,
      headers: {
        Accept: 'application/json',
      },
    },
  };
}
